export default "__VITE_ASSET__DqZ7CAIN__"